/*************************************************/
/* HEADER                                        */
/*************************************************/

export function menu() {
    const parentMenuItemSelector = '.menu-nav__item--parent';
    const menuItemParentSelector = '.menu-nav__links--list-item';
    const menuItemChildrenSelector = '.menu-nav__children';
    const menuItemChildrenListSelector = '.menu-nav__children-list';
    const activeClass = "active";
    const submenuSelector = '.menu-nav--lvl-2';
    const headerSelector = '.header';
    const headerSolidClass = 'header-solid';
    const parentMenuEnterEvents = [ 'mouseenter'];
    const parentMenuExitEvents = [ 'mouseleave'];

    const init = () => {
        const parentMenuItems = document.querySelectorAll(parentMenuItemSelector);
        const header = document.querySelector(headerSelector);

        if (parentMenuItems.length > 0) {
            parentMenuItems.forEach(item => {
                const submenu = item.querySelector(submenuSelector);
                let submenuOpened = false;
                parentMenuEnterEvents.forEach(event => {
                    item.addEventListener(event, () => {
                        item.classList.add("open");
                        toggleSubMenuVisibility(submenu, false, submenuOpened);
                        submenuOpened = true; // Mark as opened
                    });
                });

                parentMenuExitEvents.forEach(event => {
                    item.addEventListener(event, () => {
                        item.classList.remove("open");
                        toggleSubMenuVisibility(submenu, true);
                        submenuOpened = false; // Reset the flag when the submenu is closed
                    });
                });

                const menuItemParents = document.querySelectorAll(menuItemParentSelector);
                menuItemParents.forEach(menuItem => {
                    const children = menuItem.querySelector(menuItemChildrenSelector);
                    const childrenList = menuItem.querySelector(menuItemChildrenListSelector);

                    parentMenuEnterEvents.forEach(event => {
                        menuItem.addEventListener(event, () => {
                            toggleActiveClassForChildren(document.querySelectorAll(menuItemChildrenSelector), children);
                            toggleActiveClassForChildren(document.querySelectorAll(menuItemChildrenListSelector), childrenList);
                        });
                    });
                });
            });

            // Set the initial active state for the first submenu
            const firstParentMenuItem = parentMenuItems[0];
            const firstSubmenu = firstParentMenuItem.querySelector(submenuSelector);
            if (firstSubmenu) {
                setActiveFirstChild(firstSubmenu);
                firstSubmenu.setAttribute('aria-hidden', 'false');
            }
        }
    };

    const toggleSubMenuVisibility = (submenu, hidden, wasOpened = false) => {
        if (!submenu) return;

        submenu.setAttribute('aria-hidden', hidden);
        const header = document.querySelector(headerSelector);

        if (hidden) {
            header.classList.remove(headerSolidClass);
            document.querySelectorAll(menuItemChildrenSelector).forEach(e => {
                e.classList.remove(activeClass);
            });
            document.querySelectorAll(menuItemChildrenListSelector).forEach(e => {
                e.classList.remove(activeClass);
            });
        } else {
            header.classList.add(headerSolidClass);
            if (!wasOpened) {
                setActiveFirstChild(submenu); // Activate the first child of the submenu only if it wasn't opened before
            }
        }
    };

    const toggleActiveClassForChildren = (allChildren, currentChildren) => {
        allChildren.forEach(child => {
            child.classList.remove(activeClass);
        });

        if (currentChildren) {
            currentChildren.classList.add(activeClass);
        }
    };

    const setActiveFirstChild = (submenu) => {
        // Find the first menu item child
        const firstMenuItem = submenu.querySelector(`${menuItemParentSelector}:first-child`);
        if (firstMenuItem) {
            // Activate the first menu item child
            firstMenuItem.classList.add(activeClass);
            // Find and activate its children
            const firstChild = firstMenuItem.querySelector(menuItemChildrenSelector);
            const firstChildList = firstMenuItem.querySelector(menuItemChildrenListSelector);
            if (firstChild) {
                firstChild.classList.add(activeClass);
            }
            if (firstChildList) {
                firstChildList.classList.add(activeClass);
            }
        }
    };

    init();
}
